module.exports = __webpack_public_path__ + "static/media/Trofeu.ba418550.svg";